module.exports = __webpack_public_path__ + "img/checklist-app.1718c1f0.jpeg";